var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 17,
    fill: "none",
    viewBox: "0 0 26 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M17.81 10.929a2.024 2.024 0 1 0-2.428 0v1.619a1.214 1.214 0 0 0 2.428 0v-1.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    fillRule: "evenodd",
    d: "M10.119 1.619H2.024a.405.405 0 0 0-.405.405v2.833H0V2.024C0 .906.906 0 2.024 0h8.095c1.118 0 2.024.906 2.024 2.024v2.833H23.07c1.118 0 2.024.906 2.024 2.024v8.095A2.024 2.024 0 0 1 23.071 17H10.12a2.024 2.024 0 0 1-2.024-2.024V6.881c0-1.118.906-2.024 2.024-2.024h.405V2.024a.405.405 0 0 0-.405-.405Zm12.952 4.857H10.12a.405.405 0 0 0-.405.405v8.095c0 .224.181.405.405.405h12.952a.405.405 0 0 0 .405-.405V6.881a.405.405 0 0 0-.405-.405Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlockIcon.b94d2b96ede5d2bdc243d0eab5db5e4e.svg";
export { ForwardRef as ReactComponent };